export default __webpack_public_path__ + "static/media/no-eligibility.04f5801f.svg";